import HighlightValue from './HighlightValue';

export default HighlightValue;
